/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import * as consts from '../../../const.js';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, SelectDropdown } from 'tc-client-common';
import ReportsService from './reports.service';
import Loading from '../../loading/loading.component';
import Notification from '../../common/notification/notification.component';

class ReportsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: true,
      selectedSite: null
    };
    this.downloadReport = this.downloadReport.bind(this);
    this.selectSite = this.selectSite.bind(this);
  }

  componentDidMount() {
    this.props.clearReportCSV();
  }

  downloadReport() {
    const site = this.state.selectedSite;
    let payload = {
      gid: this.props.study.gid,
      userId: this.props.user.userId
    };
    if (site.value.gid) {
      payload.siteGid = site.value.gid;
    }
    this.props.downloadReportCSV(this.props.study.protocolNumber, payload).then((response) => {
      if (response.payload.objectBlob) {
        const objectBlob = response.payload.objectBlob;
        const d = new Date();
        function z(n) {
          return (n < 10 ? '0' : '') + n;
        }
        const date = d.getFullYear() + '-' + z(d.getMonth() + 1) + '-' + z(d.getDate());
        const docName = [this.props.study.protocolNumber, '-', date, '.csv'].join('');
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(objectBlob.blob, docName);
        } else {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(objectBlob.blob);
          link.setAttribute('download', docName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
  }

  selectSite(site) {
    this.setState({ disabled: false, selectedSite: site });
  }

  render() {
    const {
      error,
      isFetching,
      sites,
      study: { permissions }
    } = this.props;
    let loading = <span />,
      errorElem = <span />;

    if (isFetching) {
      loading = <Loading />;
    } else if (error) {
      errorElem = <Notification type="error" data={error} />;
    }
    const payload = {
      sites: sites,
      downloadCallbackFn: this.selectSite,
      permissions: permissions
    };
    const sitesElems = ReportsService.composeReports(payload);
    const defaultValue = { label: 'Select report', value: '' };
    const selectedSite = this.state.selectedSite;
    return (
      <div>
        <div id="reports-modal">
          <div id="reports-modal-body">
            <SelectDropdown
              id="reports-sites"
              options={sitesElems}
              selectedValue={selectedSite ? selectedSite : defaultValue}
              onChange={this.selectSite}
            />
            {loading}
            {errorElem}
          </div>
          <div id="reports-modal-footer">
            <hr className="reports-modal-divider" />
            <Button
              id="close-raports-popup"
              theme="default large-button"
              handleClick={this.props.close}
              label={consts.CLOSE}
            />
            <Button
              id="export-raports-popup"
              theme="active large-button"
              handleClick={this.downloadReport}
              label={consts.EXPORT}
              disabled={this.state.disabled}
            />
          </div>
        </div>
      </div>
    );
  }
}

ReportsModal.propTypes = {
  sites: PropTypes.array,
  user: PropTypes.object,
  close: PropTypes.func,
  clearReportCSV: PropTypes.func,
  downloadReportCSV: PropTypes.func
};

export default ReportsModal;
